import React, { Fragment } from 'react'

import yn from 'yn'

const BkFlowEnhancementsCardDescription = props => {
	const {
		hotelLabels,
		serviceDescription,
		serviceDescriptionExpanded,
		limitChars,
		serviceDescriptionEvent
	} = props

	return (
		<div className="bk-flow-enhancements__card-description">
			{ yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_DESCRIPTION_ACCORDION) &&
				serviceDescription.length > limitChars ?
				<Fragment>
					{ serviceDescription.slice(0, limitChars) }
					<span className={
						serviceDescriptionExpanded ?
							'u-txt-read-more expanded'
						:
							'u-txt-read-more'
					}>
						{ serviceDescription.slice(limitChars) }
					</span>
					<span
						onClick={ serviceDescriptionEvent }
						className="u-txt-toggle-read-more u-font-small u-font-bold"
					>
						{ serviceDescriptionExpanded ? '... ' + hotelLabels.readLess : '... ' + hotelLabels.readMore }
					</span>
				</Fragment>
			:
				serviceDescription
			}
		</div>
	)
}

export default BkFlowEnhancementsCardDescription


// WEBPACK FOOTER //
// ./src/components/enhancements/elements/BkFlowEnhancementsCardDescription.js